import { render } from "./SlideOverPanelRedesign.vue?vue&type=template&id=63447322&scoped=true"
import script from "./SlideOverPanelRedesign.vue?vue&type=script&lang=js"
export * from "./SlideOverPanelRedesign.vue?vue&type=script&lang=js"

import "./SlideOverPanelRedesign.vue?vue&type=style&index=0&id=63447322&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63447322"]])

export default __exports__